import { ScopeType } from '@/core/models/allowed-scopes.interface';
import { Scope } from '../models/allowed-scopes.interface';
import store from '../store';

export function checkAccess(scopeType: ScopeType, requiredScopes: Scope | Array<Scope>) {
   const userScopes = store.state.userInfo?.userInfo?.allowed_scopes?.[scopeType] || [];

   if (Array.isArray(requiredScopes)) {
      return requiredScopes.every((requiredScope) => userScopes.includes(requiredScope));
   }
   return userScopes.includes(requiredScopes);
}
